<template>
  <div class="epg-guide">
    <b v-if="msg">{{ msg }}</b>
    <!--
      <input v-model="msg">
      -->

      <div id="guide-time">{{currentDateFormated}}</div>
      <div class="trx-1-3" id="event-info" :class="{'event-info-active': fullInfo}">
        <div id="channel-name">{{currentChannelName}}</div>
        <div id="event-name">{{currentProgram.title}}</div>
        <div id="event-duration">{{currentProgram.start}} - {{currentProgram.end}}</div>
        <div class="event-progress">
          <div id="event-inner-progress" :style="{width: currentEventProgress }"></div>
        </div>
        <div id="event-text"> {{programDescription}}</div>
      </div>

    <div class="epgguide-table-wrapper">
      <table id="epgguide" :class="{'epgguide-inactive': fullInfo}"  ref="epgguide">
        <tbody id="epgguide-headline">
          <tr>
            <th id="guide-date">
              <div>{{currentTimelineHeaderDate}}</div>
            </th>
            <th id="timeline">
              <div id="time-position-wrapper" v-if="currentHorizontalPage <=1">

                <div id="epg-timeline-position" :style="{height: timelineHeight + 'px', marginLeft: currentTimelinePosition + '%'}"></div>


              </div>

              <template v-for="item in timelines" >
                <div class="timeline-item" :key="item.time" :style="{ width: item.percent }">{{ item.time }}</div>
              </template>

            </th>
          </tr>
        </tbody>
        <tbody id="epgguide-body" >

          <template v-for="(channel) in channelsPerPage">
            <tr :id="'entry-' + channel.position" :key="channel._id">
            <td class="channel-entry">{{channel.name}}</td>
            <td :id="'eventlist-' + channel.position"  class="eventlist">

              <template v-for="(program, pindex) in programByIndex(channel.position - 1)">
                <div :data-channelindex="channel.position"
                     :data-eventindex="pindex"
                     :id="'event-' + channel.position"
                     :style="{ width: program.percent + '%' }"
                     class="event"
                     :class="{ 'event-active': program.isActive}"
                     :key="program.id"
                 >{{program.title}}</div>
              </template>

            </td>
          </tr>
          </template>

        </tbody>
      </table>
    </div>

    <div id="epg-pager">
      <div class="arrow arrow-down float-l" :class="{'arrow-active': isDownArrowActive}" :style="cssImageArrowDown" ></div>

       <template v-for="p in maxChannelPages">
          <div :id="'epg-page-' + p" class="float-l epg-pager-item" :class="{'epg-pager-active': currentChannelPageNr === p}" v-bind:key="p" ></div>
       </template>

      <div class="arrow arrow-up float-l" :class="{'arrow-active': isUpArrowActive}" :style="cssImageArrowUp"></div>
  </div>

  </div>

</template>
<script>

import { setStartDate, timelineHeader, channelUp, channelDown, channelRight, channelLeft, getEpgForPage, eventlist, timelineStartDate, timelinePositionMarginPercent, computeChannelPage, filterChannelsForPage, computeMaxChannelPages} from '@/helpers/EpgGuide'
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import { mapState } from 'vuex';
import { NAV_TYPE } from '@/store/modules/navigation';

export default {
  mixins: [keyHandler],
  data() {
    return {
      startDate: setStartDate(),
      timelines: timelineHeader(),
      cssImageArrowUp: {
          content: `url(${require('@/assets/tiles/arrow_white_up.svg')})`
      },
      cssImageArrowDown: {
          content: `url(${require('@/assets/tiles/arrow_white_down.svg')})`
      },
      //currentChannelIndex: this.$store.state.epgGuide.tvStartChannel,
      currentChannelIndex: 0 ,
      currentEpgProgramIndex: 0,
      currentHorizontalPage: 1,
      currentActiveProgram: {},
     // currentMaxHorizontalPages: 1,
      timelineStartDate: timelineStartDate(),
      timelineStartTime: timelineStartDate().getTime(),
      currentDatetime: new Date(),
      currentDateFormated: "",
      programProgress: "0px",
      timelineHeight: 100,
      fullInfo: false,
      msg: 'EpgGuide',
      error: {
        active: false,
        message: '',
      },
    }
  },

  methods: {
    async init() {
      console.log("init epg guide");
      this.currentChannelIndex = this.$store.state.epgGuide.tvStartChannel;
      console.log("init currentChannelIndex:", this.currentChannelIndex);
      try {
        //timelineHeader()
        this.$store.dispatch('epgGuide/init');
      } catch (err) {
        console.log(err);
        this.error.active = true;
        this.error.message = 'could not fetch tv packages';
      }
    },
    programByIndex: function(id) {
      let programs = this.tvPrograms;
      return programs[id];
    },
    updateTimeLineHeader() {
      this.timelines = timelineHeader(this.currentHorizontalPage);
    },
    updateProgramTimeMarker() {
    // update red current time marker height
      this.timelineHeight = this.$refs.epgguide.offsetHeight;
    },
    setDateTime: function() {
      const today = new Date();
      this.currentDatetime = today;
      const zeroPad = (num, places) => String(num).padStart(places, '0');
      const hours = today.getHours();
      const minutes= today.getMinutes();
      this.currentDateFormated  = zeroPad(hours, 2) + ':' + zeroPad(minutes, 2);
    },
    eventHandler(key, event) {
      const params = {...this.$data, tvPrograms: this.tvPrograms} // copy + add current tv page epg data
      switch (key) {

        case KEYS.BACK:

          if (this.fullInfo) {
            this.fullInfo = !this.fullInfo;
            break;
          };

          this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
          break;
        case KEYS.ENTER:
          console.log("Enter pressed: -> show info box");
          console.log("currentChannelId: ", this.currentChannelId);

          let startChannel = {
            "index": this.currentChannelIndex,
            "id": this.currentChannelId
          }
          if (this.fullInfo) {
            this.$store.commit('tv/setEPGGuideStartChannel', startChannel , { root: true });
            this.$router.push({
              name: 'TVPlayer',
              query: { origin: 'epg' }
            });
          }
          this.fullInfo = !this.fullInfo;
          break;
        case KEYS.UP:
          console.log("Up pressed: -> move focus up");
          this.currentChannelIndex = channelUp(params)
          this.currentEpgProgramIndex = 0;
          break;
        case KEYS.DOWN:
          console.log("Down pressed: -> move focus down");
          this.currentChannelIndex = channelDown(params)
          this.currentEpgProgramIndex = 0;
          break;
        case KEYS.RIGHT:
          console.log("Right pressed: -> move focus right");
          const retValues = channelRight(params);

          this.currentEpgProgramIndex = retValues.currentEpgProgramIndex;
          const oldHorizontalPage = this.currentHorizontalPage;
          this.currentHorizontalPage = retValues.currentHorizontalPage;

          if(this.currentHorizontalPage > oldHorizontalPage ) {
            const newHorPage = getEpgForPage(this.currentHorizontalPage, this.programsByPages)
            const programs = newHorPage.map((epg, index) => eventlist(epg, index, this.currentHorizontalPage));
            console.log("H.Page " + this.currentHorizontalPage + ": ", programs);
            retValues.updateActiveStatus(programs[this.currentChannelIndex]);
            this.$store.commit('epgGuide/programs', programs);
            this.updateTimeLineHeader(); // should be automatic ??
          }

          break;
        case KEYS.LEFT:
          console.log("Left pressed: -> move focus left");

          const retValuesLeft = channelLeft(params);

          this.currentEpgProgramIndex = retValuesLeft.currentEpgProgramIndex;
          const oldHorizontalPageLeft = this.currentHorizontalPage;
          this.currentHorizontalPage = retValuesLeft.currentHorizontalPage;

          if(this.currentHorizontalPage < oldHorizontalPageLeft ) {
            const newHorPage = getEpgForPage(this.currentHorizontalPage, this.programsByPages)
            const programs = newHorPage.map((epg, index) => eventlist(epg, index, this.currentHorizontalPage));
            console.log("H.Page " + this.currentHorizontalPage + ": ", programs);

            retValuesLeft.updateActiveStatus(programs[this.currentChannelIndex]);
            this.currentEpgProgramIndex = retValuesLeft.lastProgramIndex(programs[this.currentChannelIndex]);

            this.$store.commit('epgGuide/programs', programs);
            this.updateTimeLineHeader(); // should be automatic ??
          }

          break;
      }
    },

  },
  computed: {
    tvChannels() {
      return this.$store.getters['epgGuide/tvChannels'];
      //return this.$store.state['epgGuide/tvChannels']; // ?????  does not work !! why?
    },
    tvPrograms() {
      return this.$store.getters['epgGuide/tvPrograms'];
    },
    ...mapState('epgGuide',['programsByPages', 'pool']),
    currentProgram() {

      const emptyProgram = {
        "title": "",
        "description": ""
      };

      if (this.tvPrograms.length < 1) return emptyProgram;

      const currentActiveEpgChannel = this.tvPrograms[this.currentChannelIndex]
      const currentActiveProgram = currentActiveEpgChannel[this.currentEpgProgramIndex];
      if (currentActiveProgram) {
        // eslint-disable-next-line
        this.currentActiveProgram = currentActiveProgram;
      }
      return this.currentActiveProgram;
    },
    currentChannelName() {
      if (this.tvChannels.length < 1) return "";
      return this.tvChannels[this.currentChannelIndex].name;
    },
    currentChannelId() {
      if (this.tvChannels.length < 1) return "";
      return this.tvChannels[this.currentChannelIndex]._id;
    },
    programDescription() {
      const text = (!this.fullInfo) ? "" : this.currentProgram.description;
      return text;
    },
    currentEventProgress() {
      if (!this.currentProgram.startISO) return "0%";
      const percent =  ((Date.now() - this.currentProgram.startISO.getTime()) /
        (this.currentProgram.endISO.getTime() - this.currentProgram.startISO.getTime())) *
        100;

      console.log("event progress: ", percent);

      if (percent > 100) return "100%";
      if (percent < 0) return "0%";
      return percent + "%";
    },
    currentTimelineHeaderDate() {

      const zeroPad = (num, places) => String(num).padStart(places, '0');

      const dateFormat = (date) => {
        if (!date) return "";
        const weekday = ["Su","Mo","Tu","We","Th","Fr","Sa"];
        const day = date.getDay();

        const numDate = zeroPad(date.getDate(), 2)  + "." + zeroPad(date.getMonth() + 1, 2) + '.' +  date.getFullYear();
        return weekday[day] + " " + numDate;
      };

      if (!!this.currentProgram.startISO) {
        const programDate = this.currentProgram.startISO;
        return dateFormat(programDate);
      }

      const todayDate = this.currentDatetime; // default
      return dateFormat(todayDate)
    },
    currentTimelinePosition() {
      //compute red current time marker width/distance
      return timelinePositionMarginPercent(this.currentDatetime)
    },
    channelAmount() {
      return this.tvPrograms.length;
    },
    channelsPerPage() {
      return filterChannelsForPage(this.currentChannelPageNr, this.tvChannels);
    },
    currentChannelPageNr() {
      //console.log("number of channels: ", this.channelAmount);
      const pageInfo = computeChannelPage(this.currentChannelIndex, this.channelAmount);
      return pageInfo.currentChannelPageNr;
    },
    maxChannelPages() {
      return computeMaxChannelPages(this.channelAmount);
    },
    isDownArrowActive() {
      return this.currentChannelPageNr < this.maxChannelPages;
    },
    isUpArrowActive() {
      return this.currentChannelPageNr > 1;
    },
  },
  watch: {
   currentChannelIndex(newValue) {
    this.$store.commit('epgGuide/tvStartChannel', newValue);
  }},
  created() {
    this.setDateTime(); // show time
    setInterval(this.setDateTime, 1000 * 20); // update datetime every 20 seconds
  },
  updated: function () {
    this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
        this.updateProgramTimeMarker()
      })
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>

.trx-1-3,
.trx-2-6 {
  width: 33.33333%;
}

.epg-guide {
  font-size: 6vh;
  font-family: "Helvetica", Arial, Verdana, sans-serif;
  color: #f1f1f1;
  background: #213541;
  display: block;
  height: 100vh;
  padding-left: 5vw;
  padding-right: 3vw;
  padding-top: 8vh;
  width: 100vw;
  border: 0px solid red;
}

.bg-epgGuide {
  background-image: '';
  background: #1d2d37;
}

#guide-time {
  position: absolute;
  right: 3vw;
  top: 3vh;
  font-size: 3.5vh;
}

#guide-date {
  width: 20%;
  font-size: 2.25vh;
  font-weight: 500;
  padding-top: 1.2vh;
  padding-left: 0.6vw;
  text-transform: uppercase;
}

#timeline {
  border: 0px solid white;
  width: 100%;
  height: 100%;
  background-color: #273d4a;
}

.timeline-item {
  float: left;
  text-align: left;
  font-size: 2.25vh;
  font-weight: 500;
  padding-left: 0.6vw;
  padding-top: 0.5vh;
}

.timeline-item:before {
  content: '';
  background: #ffffff;
  position: absolute;
  /* bottom: 0; */
  /* left: 0; */
  height: 2.75%;
  width: 1px;
  margin-left: -0.5vw;
}

.timeline-scala {
  width: 100%;
  height: 2vh;
  border-left: 1px solid #eeeeee;
}

#epg-timeline-position {
  border: 1px solid red;
  width: 1px;
  position: relative;
  z-index: 9999;
}

#time-position-wrapper {
  height: 4px;
  z-index: 9999;
}

.channel-entry {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 0.6vw;
  padding-left: 0.6vw;
  font-size: 2.5vh;
  height: 100%;
}

.eventlist {
  border-right: 1px solid #646464;
  border-bottom: 1px solid #646464;
}

.event {
  background-color: transparent;
  float: left;
  overflow: hidden;
  border-left: 1px solid #646464;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 6.2vh;
  padding-bottom: 1vh;
  padding-top: 1.5vh;
  padding-left: 0.6vw;
}

.event-active {
  -webkit-box-shadow: 0 0 8px 4px #0088cc;
}

#event-info {
  position: absolute;
  top: 10vh;
  right: 0px;
  background-color: #273d4a;
  padding-top: 2.2vh;
  background: rgba(0, 0, 0, 0.97);
  font-size: 2vh;
  z-index: 9;
}

#event-name {
  padding-right: 3vw;
  padding-left: 2vw;
  font-size: 3vh;
  display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
  overflow: hidden;
}

#event-text {
  padding-top: 2.2vh;
  padding-right: 3vw;
  padding-left: 2vw;
  line-height: 1.5em;
  font-size: 2.5vh;
  display: -webkit-box;
    -webkit-line-clamp: 16;
    -webkit-box-orient: vertical;  
  overflow: hidden;
}

.event-info-active {
  height: 90vh;
}

#channel-name {
  padding-right: 3vw;
  padding-left: 2vw;
  font-size: 1.5vh;
}

#event-duration {
  padding-right: 3vw;
  padding-left: 2vw;
  padding-bottom: 2vh;
  font-size: 2vh;
}

#epgguide {
  width: 100%;
  table-layout: fixed;
  border-spacing: 0px;
  border: 0px;
  padding: 0px;
  margin: 0px;
  font-size: 2vh;
  background: rgba(0, 0, 0, 0.5);
}

.epgguide-inactive {
  opacity: 0.3;
}

.epgguide-table-wrapper {
  margin-top: 15vh;
}

.event-progress {
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.5vh;
  background-color: rgba(0,136,204, 0.4);
}

#event-inner-progress {
  border: 2px solid #0088cc;
  width: 0%;
}

#epg-pager {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
  align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
  justify-content: center;
  margin-top: 4vh;
}

.epg-pager-item {
  height: 10px;
  width: 10px;
  background-color: #0088cc;
  border-radius: 50%;
  margin-left: 1vw;
  margin-right: 1vw;
  opacity: 0.2;
}

.epg-pager-active {
  opacity: 1;
}

#epgguide table,
td {
  height: 100%;
  font-size: 2.5vh;
}

#epgguide tbody:nth-child(1) {
  background-color: #273d4a;
}

.float-l {
  float: left;
}

.arrow {
  right: 3.5vw;
  opacity: 0.2;
  width: 1.8vw;
}

.arrow-up {
  /* content: url("http://portal.triax.biz/v6.2/images/svg/arrow_white_up.svg"); */
  /* content: url(v-bind(this.imageUrl)svg/arrow_white_up.svg); */
  /* content: url(${this.imageUrl}svg/arrow_white_up.svg); */
  /* content: url(var(--imageArrowUp)); */
}
/* ${process.env.IMAGE_URL} */ 
.arrow-down {
  /* content: url("http://portal.triax.biz/v6.2/images/svg/arrow_white_down.svg"); */
  /* content: url(v-bind(this.imageUrl)svg/arrow_white_down.svg); */
  /* content: url(${this.imageUrl}svg/arrow_white_down.svg); */
  /* content: url(var(--imageArrowDown)); */
}

.arrow-active {
  opacity: 1;
}

.eventlist-empty {
  border-left: 1px solid #646464;
  border-right: 1px solid #646464;
  padding-top: 1.5vh;
  padding-bottom: 1vh;
  height: 6.5vh;
  width: 100%;
}

.event-list-end {
  border-bottom: 1px solid #646464;
}
</style>



// WEBPACK FOOTER //
// src/pages/EPGGuide.vue